/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContrattoResDto } from '../../models/contratto-res-dto';

export interface ContrattiControllerDeleteContratto$Params {
  idContratto: number;
}

export function contrattiControllerDeleteContratto(
  http: HttpClient,
  rootUrl: string,
  params: ContrattiControllerDeleteContratto$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContrattoResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    contrattiControllerDeleteContratto.PATH,
    'delete',
  );
  if (params) {
    rb.path('idContratto', params.idContratto, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContrattoResDto>;
      }),
    );
}

contrattiControllerDeleteContratto.PATH = '/admin/contratti/id/{idContratto}';
